import { push } from 'react-router-redux';
import * as actions from './actions';

/**
 * Some operations are directly mapped to actions, but this would change if we
 * need more complex behavior.
 */

const selectEntity = ({ id, type }) => dispatch => {
  /**
   * Doing the routing via an action like this instead of a direct link
   * - prevents you from hardcoding url logic on a component level
   * - adds the ability to dispatch and listen for other events related to this action
   */
  switch (type) {
    case 'route':
      dispatch(push(`/map/live/routes/${id}`));
      break;
    case 'location':
      dispatch(push(`/map/live/locations/${id}`));
      break;
    case 'segment':
      dispatch(push(`/map/live/segments/${id}`));
      break;
    default:
      throw new TypeError(`Invalid entity type ${type}`);
  }
};

const unsetHoverState = () => (dispatch, getState) => {
  const { map: { currentHover } } = getState();

  /**
    An operation to kill all hover state. This is required because the leaflet
    event handlers are not robust enough. The map triggers this on mouse-over
    for example.

    This unset action only needs to be fired if there is actually an element
    in the current hover state, so we make the dispatch conditional here
    to minize action noise and unnecessary re-rendering.
  */
  if (!currentHover) {
    return;
  }

  dispatch(actions.unsetHoverState());
};

const toggleMapPanel = () => (dispatch, getState) => {
  const { map: { isMapPanelOpen } } = getState();

  if (isMapPanelOpen) {
    dispatch(actions.closeMapPanel());
  } else {
    dispatch(actions.openMapPanel());
  }
};

/**
 * Some of the actions that don't need any extra logic, are mapped directly
 * to the exported operations.
 */
export default {
  enterEntity: actions.enterEntity,
  leaveEntity: actions.leaveEntity,
  selectEntity,
  unsetHoverState,
  setBounds: actions.setBounds,
  setAllFeatureBounds: actions.setAllFeatureBounds,
  setCenter: actions.setCenter,
  setViewMode: actions.setViewMode,
  toggleMapPanel,
};



// WEBPACK FOOTER //
// ./src/state/ducks/map/operations.js